import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './Components/Contexts/CartContext';
import { ThemeProvider } from './Components/Contexts/ThemeContext'; // NEW: Import ThemeProvider
import { useCart } from './Components/Contexts/CartContext';
import React from 'react';

// Import Components
import ShoppingCartSidebar from './Components/Cart/ShoppingCartSidebar';
import NavBar from './Components/NavBar/NavBar';
import Footer from './Components/Footer/Footer';

// Import Pages
import Home from './Components/Home/Home';
import About from './Components/About/About';
import Contact from './Components/Contact/Contact';
import Services from './Components/Services/Services';
import ShopPage from './Components/Shop/ShopPage';
import CheckoutPage from './Components/Checkout/CheckoutPage';
import Repair from './Components/Services/Repair';
import Modifications from './Components/Services/Modifications';
import Custom from './Components/Services/customProjects';
import AuthPage from './Components/Auth/AuthPage';

const AppLayout = () => {
  const {
    isCartOpen,
    setIsCartOpen,
    cartItems,
    cartTotal,
    updateQuantity,
    removeItem
  } = useCart();

  return (
    <BrowserRouter>
      <div className="app-wrapper">
        <NavBar />

        <ShoppingCartSidebar
          isOpen={isCartOpen}
          onClose={() => setIsCartOpen(false)}
          cartItems={cartItems}
          cartTotal={cartTotal.toFixed(2)}
          onUpdateQuantity={updateQuantity}
          onRemoveItem={removeItem}
        />

        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/repair" element={<Repair />} />
            <Route path="/services/modifications" element={<Modifications />} />
            <Route path="/services/custom" element={<Custom />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/signin" element={<AuthPage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

// The main App component now sets up BOTH providers
const App = () => {
  return (
    <ThemeProvider> {/* NEW: Wrap with ThemeProvider */}
      <CartProvider>
        <AppLayout />
      </CartProvider>
    </ThemeProvider>
  );
};

export default App;